import React, { useState } from "react";
import { Loader } from '../../components';
import { ContactStepsIndicator, ContactWrap } from '../../components/';

const ContactContainer = (props) => {
  
  const [currentIndex, setCurrentIndex] = useState(0);
  const [indexBack, setindexBack] = useState(null);
  
  const tazza = require("../../assets/image-form.png");
  const arrayLoad = [
    tazza
  ];
  document.title = "Contact Invrsion"
  const nextStep = (index)  => {
    console.log(index !== undefined);
    
    if(index !== undefined) {
      if(index < currentIndex) {
        setindexBack(index)
        setCurrentIndex(index)
      }
    } else {
      setCurrentIndex(currentIndex + 1)
    }
  }

  return (
    <React.Fragment>
      <ContactStepsIndicator 
        index={currentIndex} 
        gotoIndex={nextStep}
      />
      <ContactWrap 
        nextStep={nextStep}
        index={indexBack} 
        img={tazza}
      >
      </ContactWrap>
      <Loader arrayLoad={arrayLoad}/>
    </React.Fragment>
  );
};

export default ContactContainer;
